"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListVpnsSortOrder = exports.ListVpnsSortByCriteria = exports.VpnType = exports.VpnState = void 0;
exports.toRank = toRank;
exports.fromRank = fromRank;
exports.validateVpnId = validateVpnId;
exports.vpnAgainstQuotaPredicate = vpnAgainstQuotaPredicate;
exports.validateVpnNbAgainstQuota = validateVpnNbAgainstQuota;
exports.filterVpns = filterVpns;
exports.sortVpns = sortVpns;
exports.newVpn = newVpn;
exports.getVpnFrom = getVpnFrom;
exports.dateToId = dateToId;
exports.idToDate = idToDate;
exports.vpnIdToWgFileName = vpnIdToWgFileName;
exports.compressVpnId = compressVpnId;
exports.vpnToClient = vpnToClient;
exports.vpnFromServer = vpnFromServer;
exports.metricsToClient = metricsToClient;
exports.getCreationDateFromVpnId = getCreationDateFromVpnId;
const uuid_1 = require("uuid");
const errors_1 = require("../errors");
const peanuts_1 = require("./peanuts");
const uservpn_1 = require("./uservpn");
const LEGACY_VPN_ID_FORMAT_REGEX = /\d{4}[01]\d[0-3]\d[0-2]\d[0-5]\d[0-5]\d\d{3}@[a-z]{2}-[a-z]+-\d/;
var VpnState;
(function (VpnState) {
    VpnState["Failed"] = "Failed";
    VpnState["Creating"] = "Creating";
    VpnState["Created"] = "Created";
    VpnState["Provisioning"] = "Provisioning";
    VpnState["Paused"] = "Paused";
    VpnState["Running"] = "Running";
    VpnState["Deprovisioning"] = "Deprovisioning";
    VpnState["Deleted"] = "Deleted";
})(VpnState || (exports.VpnState = VpnState = {}));
const vpnStateRank = Object.values(VpnState);
function toRank(state) {
    return vpnStateRank.indexOf(state);
}
function fromRank(rank) {
    return vpnStateRank[rank];
}
var VpnType;
(function (VpnType) {
    VpnType["WireGuard"] = "wireguard";
})(VpnType || (exports.VpnType = VpnType = {}));
var ListVpnsSortByCriteria;
(function (ListVpnsSortByCriteria) {
    ListVpnsSortByCriteria["CreatedAt"] = "createdAt";
    ListVpnsSortByCriteria["State"] = "state";
    ListVpnsSortByCriteria["GeonamesId"] = "geonamesId";
    ListVpnsSortByCriteria["VpnId"] = "vpnId";
    ListVpnsSortByCriteria["City"] = "city";
    ListVpnsSortByCriteria["Country"] = "country";
})(ListVpnsSortByCriteria || (exports.ListVpnsSortByCriteria = ListVpnsSortByCriteria = {}));
var ListVpnsSortOrder;
(function (ListVpnsSortOrder) {
    ListVpnsSortOrder["Asc"] = "asc";
    ListVpnsSortOrder["Desc"] = "desc";
})(ListVpnsSortOrder || (exports.ListVpnsSortOrder = ListVpnsSortOrder = {}));
function validateVpnId(vpnId) {
    // Parse the string as a uuid
    if ((0, uuid_1.validate)(vpnId))
        return uservpn_1.UserVpnVersion.LOCATIONS;
    if (LEGACY_VPN_ID_FORMAT_REGEX.test(vpnId))
        return uservpn_1.UserVpnVersion.INITIAL;
    throw new errors_1.MyTmpVpnError(`Invalid vpnId format: \'${vpnId}\'`);
}
// Return whether the given vpn should be taken into account when computing
// whether a given user has reached its quota or not
function vpnAgainstQuotaPredicate(uservpn) {
    // We return true only when the vpn is in a state that is below Running, and not Failed.
    // The idea is that those ones are either already running or will soon, so they have to be 
    // part of the quota. Others (Failed, and Deprovisioning, Deleted) are gone, so they should not count.
    return (uservpn.vpn.state !== VpnState.Failed) && (toRank(uservpn.vpn.state) <= toRank(VpnState.Running));
}
function validateVpnNbAgainstQuota(vpnNb, quota) {
    if (vpnNb >= quota) {
        throw new errors_1.InvalidUserConfigError(`User already has ${quota} active vpns. Quota reached.`);
    }
    return vpnNb;
}
function filterVpns(vpns, getLocationByGeonamesId, filterCity, filterCountry) {
    const filtered = vpns;
    return filtered.filter(vpn => {
        const cityLocation = getLocationByGeonamesId(vpn.geonamesId);
        if (!cityLocation)
            return false;
        // If no filters are applied, include all VPNs
        if (!filterCity && !filterCountry)
            return true;
        const cityMatch = filterCity && cityLocation.city.toLowerCase().includes(filterCity);
        const countryMatch = filterCountry && cityLocation.country.toLowerCase().includes(filterCountry);
        // FilterCity  | FilterCountry
        // undefined   | undefined    -> true (handled above)
        // match       | undefined    -> cityMatch
        // unmatch     | undefined    -> false
        // undefined   | match        -> countryMatch
        // undefined   | unmatch      -> false
        // match       | match        -> cityMatch && countryMatch
        // match       | unmatch      -> cityMatch && false
        // unmatch     | match        -> false && countryMatch
        // unmatch     | unmatch      -> false && false
        const bothMatch = cityMatch && countryMatch;
        // Either both city and country match the filter
        // or one of them is undefined and the other matches
        return bothMatch || (!filterCountry && cityMatch) || (!filterCity && countryMatch);
    });
}
function sortVpns(vpns, getCityByGeonamesId, sortBy = ListVpnsSortByCriteria.CreatedAt, sortOrder = ListVpnsSortOrder.Desc) {
    if (!sortBy) {
        return vpns;
    }
    const sorted = [...vpns].sort((a, b) => {
        let compareResult = 0;
        const aCityLocation = getCityByGeonamesId(a.geonamesId);
        const bCityLocation = getCityByGeonamesId(b.geonamesId);
        switch (sortBy) {
            case ListVpnsSortByCriteria.City:
                compareResult = aCityLocation.city.localeCompare(bCityLocation.city);
                break;
            case ListVpnsSortByCriteria.Country:
                compareResult = aCityLocation.country.localeCompare(bCityLocation.country);
                break;
            case ListVpnsSortByCriteria.GeonamesId:
                compareResult = a.geonamesId - b.geonamesId;
                break;
            case ListVpnsSortByCriteria.State:
                compareResult = toRank(a.state) - toRank(b.state);
                break;
            case ListVpnsSortByCriteria.CreatedAt:
            default:
                compareResult = a.createdAt.getTime() - b.createdAt.getTime();
                break;
        }
        return sortOrder === ListVpnsSortOrder.Desc ? -compareResult : compareResult;
    });
    return sorted;
}
function newVpn(geonamesId, config, state) {
    if (!Number.isInteger(geonamesId) || geonamesId <= 0) {
        throw new errors_1.MyTmpVpnError(`Incorrect geonamesId: \'${geonamesId}\'`);
    }
    const createdAt = new Date();
    const vpnId = (0, uuid_1.v4)();
    // Assert we will be able to deserialize later on...
    validateVpnId(vpnId);
    return {
        vpnId,
        createdAt,
        geonamesId,
        config,
        state
    };
}
function getVpnFrom(vpnId, createdAt, geonamesId, state, config, startedAt) {
    const version = validateVpnId(vpnId);
    let finalCreatedAt;
    switch (version) {
        case uservpn_1.UserVpnVersion.INITIAL:
            // Legacy vpnId format, the createdAt is given from the vpnId itself
            if (createdAt !== undefined) {
                throw new errors_1.MyTmpVpnError(`Invalid parameter: createdAt must be undefined when vpnId version is INITIAL: vpnId=${vpnId}; createdAt=${createdAt}`);
            }
            const tokens = vpnId.split('@');
            if (tokens.length !== 2) {
                throw new errors_1.MyTmpVpnError(`Incorrect vpnId: ${vpnId}`);
            }
            finalCreatedAt = idToDate(tokens[0]);
            break;
        case uservpn_1.UserVpnVersion.LOCATIONS:
            // New vpnId format
            if (createdAt === undefined) {
                throw new errors_1.MyTmpVpnError(`Invalid parameter: createdAt can't be undefined: vpnId=${vpnId}`);
            }
            finalCreatedAt = createdAt;
            break;
        default:
            throw new errors_1.MyTmpVpnError(`Incorrect version: \'${version}\'`);
    }
    return {
        vpnId,
        createdAt: finalCreatedAt,
        ...(startedAt !== undefined && { startedAt }),
        geonamesId,
        config,
        state
    };
}
// Using a date from an id is convenient for debugging.
// We can't use Date.toISOString() because some characters are forbidden
// E.g: SFn refuse the ':'
// So we need convertor back and forth
function dateToId(date) {
    // YYYY-MM-DDTHH:mm:ss.uuuZ -> YYYYMMDDHHmmssuuu
    return date.toISOString().replace(/[^\d]/g, '');
}
function idToDate(id) {
    // YYYYMMDDHHmmssuuu -> YYYY-MM-DDTHH:mm:ss.uuuZ
    const year = id.substring(0, 4);
    const month = id.substring(4, 6);
    const day = id.substring(6, 8);
    const hour = id.substring(8, 10);
    const minute = id.substring(10, 12);
    const second = id.substring(12, 14);
    const millis = id.substring(14);
    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}.${millis}Z`);
}
// The WireGuard configuration file name (without .conf) is used as the network interface name.
// Linux limits interface names to 15 characters (IFNAMSIZ).
// The WireGuard Mobile Application also requires: "[a-zA-Z0-9_=+.-]{1,15}"
// https://git.zx2c4.com/wireguard-android/tree/tunnel/src/main/java/com/wireguard/android/backend/Tunnel.java#n19
//
// Naming scheme (all ≤15 chars without .conf):
//   Single peer:          {8hex}.conf
//   Single peer IPv6:     {8hex}-ip6.conf
//   Multi-peer IPv4:      {8hex}-{N}.conf
//   Multi-peer IPv6:      {8hex}-ip6-{N}.conf
function vpnIdToWgFileName(vpn, options) {
    const id = compressVpnId(vpn);
    const peerIndex = options?.peerIndex;
    const ipv6 = options?.ipv6 ?? false;
    if (peerIndex !== undefined && peerIndex > 0) {
        // Multi-peer
        if (ipv6) {
            return `${id}-ip6-${peerIndex}.conf`;
        }
        return `${id}-${peerIndex}.conf`;
    }
    // Single peer
    if (ipv6) {
        return `${id}-ip6.conf`;
    }
    return `${id}.conf`;
}
function compressVpnId(vpn) {
    const version = validateVpnId(vpn.vpnId);
    // We won't use a date-based approach as it leads to collisions, especially when testing at scale
    // and it does not provide easy reverse mappping. Instead, we will use the first 8 hex chars of the UUID.
    // Collision will be negligable: using the birthday 
    // problem [[ref](https://en.wikipedia.org/wiki/Birthday_problem)] the probability of at least one 
    // collision among n items ≈ 1 - e^(-n²/2k) where k = 2^32. For our case:
    // | Active VPNs per user	| Collision probability
    // -----------------------------------------------
    // | 10	                  | ~0.000001%
    // | 100                  |	~0.0001%
    // | 1,000                |	~0.01%
    // | 9,300                |	~1%
    // -----------------------------------------------
    return vpn.vpnId.substring(0, 8);
}
function vpnToClient(vpn) {
    return {
        vpnId: vpn.vpnId,
        state: vpn.state,
        geonamesId: vpn.geonamesId,
        createdAt: vpn.createdAt,
        ...(vpn.startedAt !== undefined && { startedAt: vpn.startedAt }),
        config: {
            type: vpn.config.type,
            deleteAfter: vpn.config.deleteAfter,
            maxPeanuts: (0, peanuts_1.peanutsToClient)(vpn.config.maxPeanuts),
            port: vpn.config.port,
            dns: vpn.config.dns,
            ...(vpn.config.instanceType !== undefined && { instanceType: vpn.config.instanceType }),
            ...(vpn.config.peerCount !== undefined && vpn.config.peerCount > 1 && { peerCount: vpn.config.peerCount }),
        }
    };
}
function vpnFromServer(vpn) {
    // Transform from JSON to Plain object, especially Date object are not de-serialized automatically
    return {
        vpnId: vpn.vpnId,
        createdAt: new Date(vpn.createdAt),
        ...(vpn.startedAt !== undefined && { startedAt: new Date(vpn.startedAt) }),
        geonamesId: vpn.geonamesId,
        config: vpn.config,
        state: vpn.state,
    };
}
function metricsToClient(metrics) {
    return (metrics != null)
        ? {
            duration: metrics.duration,
            bytes: metrics.bytes,
            peanuts: (0, peanuts_1.peanutsToClient)(metrics.peanuts)
        }
        : {
            duration: Number.NaN,
            bytes: Number.NaN,
            peanuts: Number.NaN,
        };
}
/**
 * Extract the creation date from a VPN ID
 * VPN ID format: {dateToId(createdAt)}@{region}
 */
function getCreationDateFromVpnId(vpnId) {
    validateVpnId(vpnId);
    const tokens = vpnId.split('@');
    if (tokens.length !== 2) {
        throw new errors_1.MyTmpVpnError(`Invalid VPN ID format: ${vpnId}`);
    }
    return idToDate(tokens[0]);
}
